import { createAction, props } from '@ngrx/store';
import { Guid } from 'guid-typescript';

export const loadOperation = createAction('[Operation] Load Operation', props<{ id: Guid }>());

export const loadOperationSuccess = createAction('[Operation] Load Operation Success', props<{ data: any }>());

export const loadOperationFailure = createAction('[Operation] Load Operation Failure', props<{ error: any }>());
